import { render, staticRenderFns } from "./Crossing.vue?vue&type=template&id=64b29ac0&scoped=true&"
import script from "./Crossing.vue?vue&type=script&lang=js&"
export * from "./Crossing.vue?vue&type=script&lang=js&"
import style0 from "./Crossing.vue?vue&type=style&index=0&id=64b29ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b29ac0",
  null
  
)

export default component.exports